import type { Locale } from "antd/es/locale";
import enUS from "antd/locale/en_US";
import esES from "antd/locale/es_ES";
import deDE from "antd/locale/de_DE";
import ptBR from "antd/locale/pt_BR";

const LOCALES: Record<string, Locale> = {
  en: enUS,
  es: esES,
  de: deDE,
  "pt-BR": ptBR,
};

/** Ant Design locale pack for a BCP-47 tag (falls back to English). */
export function antdLocaleForLanguage(language: string | undefined): Locale {
  const tag = language || "en";
  return LOCALES[tag] ?? LOCALES[tag.split("-")[0] ?? ""] ?? enUS;
}
